module.exports = __webpack_public_path__ + "img/ar-bean-bag-toss.66f2e203.png";